import React, { useEffect, useState } from "react";
import { imgBaseUrl } from "../../api/api";

export default function StudentTransferCertificate({ data }) {
  const [setting, setSetting] = useState({});

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") || "{}"));
  }, []);

  return (
    <>
      <style>
        {`
.tc-page {
  width: 210mm;
  min-height: 297mm;
  padding: 30px;
  font-family: "Times New Roman", serif;
  position: relative;
  background: #fff;
}

/* watermark */
.tc-page::before {
  content: "";
  position: absolute;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 500px;
  height: 500px;

  background-image: url(${imgBaseUrl + setting?.logo_img});
  background-size: contain;
  background-repeat: no-repeat;

  opacity: 0.2;
}

/* content */
.tc-content {
  position: relative;
  z-index: 1;
}

/* title */
.tc-title {
  border: 1px solid #000;
  padding: 8px 40px;
  font-weight: bold;
  display: inline-block;
    border-radius: 10px; 

}

/* dotted line */
.line {
  border-bottom: 1px dotted #000;
  display: inline-block;
  width: 250px;
  margin: 0 5px;
}
.line.sort {
  border-bottom: 1px dotted #000;
  display: inline-block;
  width: 80px; 
    font-weight: bold;
  padding-bottom: 2px;
}

.line.long {
  width: 400px;
}

/* spacing */
.tc-text p {
  margin-bottom: 10px;
  font-size: 18px;
}
.tc-text .line.long {
  font-weight: bold;
}
.tc-text .line {
  font-weight: bold;
}
`}
      </style>

      <div className="tc-page">
        <div className="tc-content">
          {/* HEADER */}
          <div className="text-center" style={{ lineHeight: "0.9" }}>
            <h1
              style={{
                color: "#4CAF00",
                fontSize: "45px",
                marginBottom: "5px",
                letterSpacing: "2px",
              }}
            >
              {setting?.name}
            </h1>

            <p
              style={{
                margin: 0,
                fontSize: "20px",
                color: "#555",
              }}
            >
              <span> {setting?.village} </span> <br /> {setting?.district},{" "}
              {setting?.state} - {setting?.pin_code}
            </p>
          </div>

          <div className="d-flex align-items-center justify-content-between mt-3">
            {/* Left */}
            <div>
              Sl. No.
              <span className="line sort ms-2">
                {data?.student_info?.registration_no}
              </span>
            </div>

            {/* Center Logo */}
            <div className="text-center">
              <img
                src={imgBaseUrl + setting?.logo_img}
                style={{
                  width: "100px",
                  objectFit: "contain",
                }}
                alt="logo"
              />
            </div>

            {/* Right */}
            <div>
              Date
              <span className="line sort ms-2">
                {data.student_info.admission_date
                  .split("-")
                  .reverse()
                  .join("-")}
              </span>
            </div>
          </div>

          {/* TITLE */}
          <div className="text-center my-3">
            <span className="tc-title">
              TRANSFER / SCHOOL LEAVING CERTIFICATE
            </span>
          </div>

          {/* BODY */}
          <div className="tc-text">
            <p>
              This is to certify that Shri/Miss
              <span className="line long">{data?.student_info?.name}</span>
            </p>

            <p>
              Son/Daughter of Shri/Late
              <span className="line long">
                {data?.student_info?.father_name}
              </span>
            </p>

            <p>
              Village/Town <span className="line long"></span> <br />
              of District
              <span className="line"> {data?.student_info?.district}</span>{" "}
              State:
              <span className="line"> {data?.student_info?.state}</span>
            </p>

            <p>
              was admitted to the School on
              <span className="line"></span> and left on
              <span className="line"></span>
            </p>

            <p>
              He/She was reading in class
              <span className="line"></span> (in words) and passed to class
              <span className="line"></span>
            </p>

            <p>
              Class <span className="line"></span> (in words)
            </p>

            <p>
              He/She passed/failed in the examination held in
              <span className="line"></span> 20____ under the board.
            </p>

            <p>All the dues are cleared.</p>

            <p>
              Date of Birth according to register is
              <span className="line long">
                {new Date(data?.student_info?.dob).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })}
              </span>
            </p>

            <p>
              (in words) <span className="line long"></span>
            </p>

            <p>
              His/Her character and conduct were
              <span className="line">Good</span>
            </p>

            <p>
              <b>Reasons for leaving School:</b>
            </p>

            <ol>
              <li>Unavoidable change of residence</li>
              <li>Ill Health</li>
              <li>Completion of School Course</li>
              <li>Minor reasons</li>
              <li>Guardian option</li>
            </ol>
          </div>

          {/* FOOTER */}
          <div className="d-flex justify-content-between mt-5">
            <div>
              <div>
                Date:
                <span className="line sort ms-2">
                  {new Date()
                    .toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                    .replace(/\//g, "-")}
                </span>{" "}
              </div>
              <div>
                Place:
                <span className="line sort ms-2">{setting?.district}</span>
              </div>
            </div>

            <div className="text-end ">
              <p>Principal</p>
              <p style={{ fontWeight: "bold" }}>{setting?.name}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
